import React from "react";

import ThumbNavigationLink from "@/components/thumb-navigation-link";
import { cn } from "@/utils/cn";

import { useNavigationItems } from "./sidebar/useNavigationItems";

const ThumbNavigation = () => {
  const navigationItems = useNavigationItems();

  if (!navigationItems) return null;

  return (
    <div
      className={cn(
        "thumb-navigation",
        "fixed inset-x-0 bottom-0 lg:hidden",
        "bg-background/90 backdrop-blur-md",
        "border-t",
        "z-50 flex w-full shadow-2xl",
        "overflow-x-auto",
      )}
    >
      <ThumbNavigationLink {...navigationItems.home} />
      <ThumbNavigationLink {...navigationItems.groups} />
      <ThumbNavigationLink {...navigationItems.discover} />

      {navigationItems.predict.enabled ? (
        <>
          <ThumbNavigationLink {...navigationItems.predict} />
          <ThumbNavigationLink {...navigationItems.alerts} />
        </>
      ) : (
        <>
          <ThumbNavigationLink {...navigationItems["ai-search"]} />
          <ThumbNavigationLink {...navigationItems.alerts} />
          <ThumbNavigationLink {...navigationItems.chats} />
        </>
      )}
    </div>
  );
};

export default ThumbNavigation;
